import baseOnOff from "./_internal/_baseOnOff.js";

export default baseOnOff("addEventListener");
